module.exports = __webpack_public_path__ + "media/img/hk-585fb76ecf1cf61fd5d823417b123b7a.png";